import { LogLevel } from '@amplitude/types';
export { version as SDK_VERSION } from '../package.json';
export var SDK_NAME = 'amplitude-node';
export var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
export var BASE_RETRY_TIMEOUT_DEPRECATED = 100;
// Default 10 second event timeout
export var BASE_RETRY_TIMEOUT_DEPRECATED_WARNING = 'DEPRECATED. Please use retryTimeouts. It will be converted to retryTimeouts with exponential wait times (i.e. 100ms -> 200ms -> 400ms -> ...)';
export var REQUEST_TIMEOUT_MILLIS_DEFAULT = 10000;
// The overridable constants of the node SDK
export var DEFAULT_OPTIONS = {
    serverUrl: AMPLITUDE_SERVER_URL,
    debug: false,
    // 2kb is a safe estimate for a medium size event object. This keeps the SDK's memory footprint roughly
    // under 32 MB.
    maxCachedEvents: 16000,
    logLevel: LogLevel.None,
    optOut: false,
    retryTimeouts: [100, 100, 200, 200, 400, 400, 800, 800, 1600, 1600, 3200, 3200],
    // The client will instantiate the retry/transport classes if not defined
    retryClass: null,
    transportClass: null,
    // By default, events flush on the next event loop
    uploadIntervalInSec: 0,
    minIdLength: null,
    onRetry: null,
    requestTimeoutMillis: REQUEST_TIMEOUT_MILLIS_DEFAULT,
};
//# sourceMappingURL=constants.js.map